<template>
  <div class="mag-t10">
    <van-pull-refresh v-model="isLoading" @refresh="getPointApplyInfo">
      <div ref="fresh" :style="{height:freshHeight +'px','overflow-y':'scroll','box-sizing': 'border-box','padding-bottom':'100px'}">
        <van-checkbox-group ref="checkboxGroup" v-model="result">
          <van-swipe-cell
            v-for="(info, index) in workLeaves"
            :key="index"
          >
            <van-cell class="bor-bom">
              <template #title>
                <span>申请人：{{ info.user_name }}</span>
              </template>
              <template #icon>
                <van-checkbox
                  v-if="$parent.sel_status === '0'"
                  ref="checkboxes"
                  :name="info.id"
                  icon-size="16px"
                  class="mar-rig16"
                />
              </template>
              <template slot="label">
                <font class="font-s10">{{ info.apply_date }}</font>
              </template>
              <span>
                <font class="font-s10">申请对象：{{ info.applicant_name }}</font>
              </span>
              <br>
              <span>
                <font class="font-s10">申请积分：</font>
                <font class="font-col">{{ info.score }}</font>
              </span>
            </van-cell>
            <template #right>
              <van-button
                square
                text="查看"
                type="info"
                class="button-size"
                @click="toEducationalPointsApply(workLeaves[index])"
              />
              <van-button
                square
                text="同意"
                type="primary"
                class="button-size"
                :disabled="info.approval_status === '0'? false:true"
                @click="onClickCommit(info,'2')"
              />
              <van-button
                square
                text="拒绝"
                type="danger"
                class="button-size"
                :disabled="info.approval_status === '0'? false:true"
                @click="onClickCommit(info,'1')"
              />
            </template>
          </van-swipe-cell>
        </van-checkbox-group>
      </div>
    </van-pull-refresh>
    <van-tabbar v-if="$parent.sel_status === '0'" style="bottom:50px;">
      <van-tabbar-item style="align-items: flex-start;padding-left: 16px;">
        <van-checkbox v-model="checked" icon-size="16px" @click="checkAll">全选</van-checkbox>
      </van-tabbar-item>
      <van-tabbar-item style="align-items: flex-end;padding-right: 16px;">
        <van-button type="primary" size="small" @click="onClickAllCommit('2')">同意</van-button>&nbsp;&nbsp;&nbsp;
        <van-button type="danger" size="small" @click="onClickAllCommit('1')">拒绝</van-button>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { GetPointApplyInfo, IpdApprovalStatusMobile } from '@/api/EducationalPoints'
import { Dialog } from 'vant'
import { Notify } from 'vant'
export default {
  name: 'TableData',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Notify.Component.name]: Notify.Component
  },
  data() {
    return {
      workLeaves: [],
      isLoading: false,
      freshHeight: '100%',
      result: [],
      checked: false,
      checkedAll: false
    }
  },
  watch: {
    // check全选
    result() {
      if (this.result.length === this.workLeaves.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 获取积分申请信息
    getPointApplyInfo() {
      const that = this
      const parse = {}
      // 检索用户的id
      parse.search_user_id = that.$parent.department
      // 检索批准状态(0:未批准 1:拒绝 2:批准)
      parse.search_approval_status = that.$parent.sel_status
      // 检索日期开始日
      parse.search_date_f = that.$parent.Point_data_s
      // 检索日期结束日
      parse.search_date_t = that.$parent.Point_data_e
      // 批准人id
      parse.approval_user_id = that.$store.getters.usercode
      GetPointApplyInfo(parse, function(res) {
        if (res.code === 0) {
          that.workLeaves = JSON.parse(res.data)
        } else {
          that.workLeaves = []
        }
        that.isLoading = false
      })
    },
    // 全选
    checkAll() {
      this.checked = !this.checked
      this.checkedAll = !this.checkedAll
      this.$refs.checkboxGroup.toggleAll(this.checkedAll)
    },
    // 多条审批同意拒绝
    onClickAllCommit(flg) {
      if (this.result.length !== 0) {
        Dialog.confirm({
          title: '提示',
          message: '是否确认审批?'
        })
          .then(() => {
            this.AllCommit(flg)
            // on confirm
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    // 多条审批同意拒绝数据接口整理
    AllCommit(flg) {
      const array = []
      this.result.forEach(item => {
        const parse = {}
        // 编号
        parse.id = item
        // 批准状态 拒绝
        parse.approval_status = flg
        // 批准者id
        parse.approval_user_id = this.$store.getters.usercode
        // 批准者姓名
        parse.approval_user_name = this.$store.getters.username
        parse.refuse_reason = null
        array.push(parse)
      })
      const that = this
      IpdApprovalStatusMobile(array, function(res) {
        if (res.code === 0) {
          Notify({ type: 'success', message: flg === '1' ? '拒绝成功' : '审批成功', duration: 1000 })
          // 获取积分申请信息
          that.getPointApplyInfo()
        } else {
          Notify({ type: 'danger', message: flg === '1' ? '拒绝失败' : '审批失败', duration: 1000 })
        }
      })
    },

    // 单条审批
    onClickCommit(info, flg) {
      Dialog.confirm({
        title: '提示',
        message: '是否确认审批?'
      })
        .then(() => {
          this.Commit(info, flg)
        })
        .catch(() => {
          // on cancel
        })
    },
    // 单条审批
    Commit(info, flg) {
      const array = []
      const parse = {}
      parse.id = info.id
      parse.approval_status = flg
      parse.approval_user_id = this.$store.getters.usercode
      parse.approval_user_name = this.$store.getters.username
      parse.refuse_reason = null
      array.push(parse)
      const that = this
      IpdApprovalStatusMobile(array, function(res) {
        if (res.code === 0) {
          Notify({ type: 'success', message: flg === '1' ? '拒绝成功' : '审批成功', duration: 1000 })
          // 获取积分申请信息
          that.getPointApplyInfo()
        } else {
          Notify({ type: 'danger', message: flg === '1' ? '拒绝失败' : '审批失败', duration: 1000 })
        }
      })
    },
    toEducationalPointsApply(val) {
      this.$router.push(
        { name: 'EducationalPointsApply', params: { data: val, flg: 'TableData' }}
        // { path: '/EducationalPointsApply' }
      )
    }
  }
}
</script>
<style scoped>
.font-s10{
  font-size: 13px;
}
.font-col{
  color: #FFA500;
}
.bor-bom{
  border-bottom: 1px solid #EBEDF0;
  height: 66px;
}
.button-size{
    height: 100%;
}
.mar-rig16{
  margin-right: 16px;
}
.mag-t10{
  margin-top: 1px;
}
</style>
